/* eslint-disable react/prefer-stateless-function */
import React from "react";
import { Link } from "react-router-dom";
import "../styles/styles.scss";
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

class EventPopup extends React.Component {
  render() {
    return (
      <Translation>{tr => (<div>
        {this.props.childProps.showAlert && (
          <div id="overlay">
            <div className="card mb-3">
              <div className="card-header">
                <div className="redLine">
                  <div className="title">
                    <h2>{tr("public:note_21")}</h2>
                  </div>
                  <div className="line" style={{ marginTop: "15px", marginLeft: "2px", marginRight: "4px" }} />
                  <img
                    src="../../resources/offer/timetable/cross.ico"
                    title={tr("common:close")}
                    alt={tr("common:close")}
                    onClick={() => { this.props.childProps.toggleAlert(); }}
                    className="deleteIcon float-right"
                    width="30"
                    height="30"
                    style={{ marginBottom: "5px" }}
                  />
                </div>
              </div>
              <div className="card-body" style={{ maxHeight: 'calc(100vh - 350px)', overflowY: 'auto' }}>
                <div style={{ textAlign: "justify" }}>{tr("public:pleaseNoteFrom1September2020PleaseSendBank_24")} <Link onClick={() => { this.props.childProps.toggleAlert(); }} to="/payment">{tr("public:bankAccount_25")}</Link>.
                </div>
              </div>
              <div className="card-footer" />
            </div>
          </div>
        )
        }
      </div>)}</Translation>
    );
  }
}


export default EventPopup;

EventPopup.propTypes = {
  childProps: PropTypes.object.isRequired,
};
